<!-- 紧缺库存采购>库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase" @click="gotoQuickBuy()">{{ permission.stockPurchase }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码、互换码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" v-filter-special-char="searchData.APCode" placeholder="汽配编码、互换码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" v-filter-special-char="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" v-filter-special-char="searchData.AutoSerise" placeholder="适用车型"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.BrandName"
                        filterable
                        clearable
                        size="small"
                        @change="brandChange()"
                        @visible-change="brandVisibleChange($event)"
                        style="width: 100%"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 100%" v-model="searchData.ExAttribute1" filterable clearable @visible-change="classifyVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column min-width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="GoodCode" label="互换码" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip></el-table-column>
                    <el-table-column width="250px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="CostPrice" label="成本价格" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="Price" label="批发价格" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="MarketPrice" label="零售价格" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="Inventory" label="库存" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="ExAttribute1" label="汽配分类" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="140" prop="Brand" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="140" prop="Origin" label="产地" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Quality" label="重量" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="140" prop="Size" label="尺寸" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Texture" label="材质" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Color" label="颜色" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        breadcrumb
    },
    data() {
        return {
            multipleSelection: [],
            brand: [],
            noData: false,
            typeList: [],
            goodsType: '',
            APMsgVisible: false,
            EntpTempGoodsId: '',
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                ExAttribute1: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getPermission('inventoryBuy');
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转直接采购
        gotoQuickBuy() {
            if (!this.multipleSelection[0]) {
                this.$util.warningMsg('请选择汽配');
                return;
            }
            this.$util.setLocalStorage('QuickBuyAP', this.multipleSelection);
            this.$router.push('/purchaseManage/stockPurchase/easyPurchase_new?type=3');
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.RemainingInventoryQuantity < row.ExAttribute3) {
                return 'error-row';
            }
            return '';
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                ExAttribute1: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 选中汽配分类
        chooseNode(data) {
            if (data) {
                this.goodsType = data.Item.Name;
                this.searchData.CascadeId = data.Item.CascadeId;
            } else {
                this.goodsType = '';
                this.searchData.CascadeId = '';
            }
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterpriseInventoryPartList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    for (let i = 0; i < data.length; i++) {
                        data[i].AutoSeries = [];
                    }
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.EntpTempGoodsId = event.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;
    p {
        padding-top: 10px;
    }
}
.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}
.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.qp-cover {
    text-align: center;
    overflow: hidden;
    img {
        max-height: 218px;
        max-width: 218px;
    }
}
.ops-ctn {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
}
@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}
@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.el-table .warning-row {
    background: oldlace;
}
.el-table .success-row {
    background: #f0f9eb;
}
.el-table .error-row {
    background: rgb(255, 176, 176);
}
</style>
